export default {
  namespaced: true,
  state: {
    support: false,
  },
  mutations: {
    open(state, target) {
      if (state[target] === undefined) throw new Error(`Cannot find state named "${target}"`);
      state[target] = true;
    },
    close(state, target) {
      if (state[target] === undefined) throw new Error(`Cannot find state named "${target}"`);
      state[target] = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogue.js